import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'payee-chip-dropdown',
  templateUrl: './chip-dropdown.component.html',
  styleUrls: ['./chip-dropdown.component.scss']
})
export class ChipDropdownComponent implements AfterViewInit, OnDestroy {
  @Input() selected: null | unknown = null;
  @Input() placeholder = '';
  @Input() displayWith = (selected: unknown): string => '';

  @Output() removed = new EventEmitter<void>();

  @Input() dropdownOpen = false;
  @Output() dropdownOpenChange = new EventEmitter<boolean>();

  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;

  private readonly destroy = new Subject<void>();

  ngAfterViewInit() {
    // Subscribe to dropdownOpen changes
    this.dropdownOpenChange
      .pipe(takeUntil(this.destroy))
      .subscribe(isOpen => {
        if (isOpen) {
          // Wait for the dropdown to be rendered
          setTimeout(() => {
            const firstInput = this.dropdownMenu?.nativeElement?.querySelector('input');
            if (firstInput) {
              firstInput.focus();
            }
          });
        }
      });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  openDropdown(): void {
    this.dropdownOpen = true;
    this.dropdownOpenChange.emit(true);
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
    this.dropdownOpenChange.emit(false);
  }
}
